import { Hidden } from "@material-ui/core";
import Skeleton from "@material-ui/core/Skeleton";
import Typography from "@material-ui/core/Typography";
import React from "react";
import numberFormat from "../../../../utils/formatNumber";
import DynamicPastPeriod from "./DynamicPastPeriod";
import { PastPeriodFC } from "./types";

const PastPeriod: PastPeriodFC = ({
  isLoading,
  value = 0,
  suffix,
  text,
  dynamic,
}) => {
  let valueNode: React.ReactNode;
  if (isLoading) {
    valueNode = (
      <Skeleton width={30} sx={{ display: "inline-block", mr: 0.5 }} />
    );
  } else {
    valueNode = numberFormat(value, 0);
  }
  return (
    <>
      <Typography variant={"subtitle2"} noWrap>
        {`${text}: `}
        {valueNode}
        {" " + suffix}
      </Typography>
      <Hidden smDown>
        <DynamicPastPeriod value={dynamic} isLoading={isLoading} />
      </Hidden>
    </>
  );
};

export default PastPeriod;
